export const SENTIMENT_DISTRIBUTION_BAR = {
  //'title': '',
  xAxis: [{
    data: [],

    //boundaryGap: false,
    axisTick: {
      show: false
    },
    axisLabel: {
      interval: 0,
      rotate: 45,
    },
    //是否去掉网格线
    splitLine: {
      show: false
    },
    //是否显示网格区域
    splitArea: {
      show: false
    },

    axisLine: {
      lineStyle: {
        color: '#bfbfbf',
        width: 1, //这里是为了突出显示加上的
      }
    }

  }],
  yAxis: {
    splitLine: {
      lineStyle: {
        // 使用深浅的间隔色
        color: ['#0087ED']
      }
    },
    nameTextStyle: {
      color: ['#0087ED']
    },
    axisLine: {
      lineStyle: {
        color: '#bfbfbf',
        width: 1, //这里是为了突出显示加上的
      }
    }
  },
  dataZoom: [{
      show: true,
      flowrealtime: true,
      start: 0,
      endValue: 8,
      minValueSpan: 8
    },
    {
      type: 'inside',
      flowrealtime: true,
      startValue: 0,
      endValue: 8,
      minValueSpan: 8
    }
  ],
  grid: {
    left: '15%',
    right: '4%',
    bottom: '20%',
    top: '3%',
    containLabel: false
  },
  xRotate: 60,
  series: [{
    type: 'bar',
    'name': '来源网站',
    barWidth: 50,
    areaStyle: {
        
    },
    'data': [],
    itemStyle: {
      normal: {
        color: '#ff751a'
      }
    }
  }]
}



// WEBPACK FOOTER //
// ./src/components/sentiment/config/sentimentDistributionBar.js